// value represents markdown name in the ./docs/ and is used to import in handleSetHostingProvider
export const registerOptions = [
  {
    value: 'godaddy',
    label: 'GoDaddy',
  },
  {
    value: 'cloudflare',
    label: 'Cloudflare',
  },
  {
    value: 'google',
    label: 'Google Domains',
  },
  {
    value: 'aws',
    label: 'Amazon Web Services',
  },
  {
    value: 'bluehost',
    label: 'BlueHost',
  },
  {
    value: 'dnspark',
    label: 'DNS Park',
  },
  {
    value: 'dreamhost',
    label: 'Dream Host',
  },
  {
    value: 'gandi',
    label: 'Gandi',
  },
  {
    value: 'homestead',
    label: 'Homestead',
  },
  {
    value: 'hostgator',
    label: 'HostGator',
  },
  {
    value: 'ionos',
    label: 'IONOS (old 1&1 Web Hosting)',
  },
  {
    value: 'iwantmyname',
    label: 'iwantmyname',
  },
  {
    value: 'namecom',
    label: 'Name.com',
  },
  {
    value: 'namecheap',
    label: 'NameCheap',
  },
  {
    value: 'networksolutions',
    label: 'Network Solutions',
  },
  {
    value: 'noip',
    label: 'No-IP',
  },
  {
    value: 'registercom',
    label: 'register.com',
  },
  {
    value: 'yahoo',
    label: 'Yahoo Small Business',
  },
  {
    value: 'other',
    label: `It's not on this list`,
  },
];
